module.exports = __webpack_public_path__ + "media/MRI2-ad.74394e1f.mp3";